export default __webpack_public_path__ + "static/media/RGD.d7316c8b.svg";